import * as React from "react";
const SvgLocation = props => <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21.9 32" style={{
  enableBackground: "new 0 0 21.9 32"
}} xmlSpace="preserve" {...props}><path style={{
    clipPath: "url(#SVGID_00000173866596970098475930000016776180707716386198_)",
    fill: "none",
    stroke: "#91D0D2",
    strokeMiterlimit: 10
  }} d=" M15.4,11.2c0-2.4-2-4.5-4.4-4.6c-2.4,0-4.5,2-4.5,4.4c0,2.5,1.9,4.5,4.4,4.5C13.3,15.7,15.4,13.6,15.4,11.2z M11,30.2 c-3.2-5.2-6.3-10-9.1-15C0,11.9,0.8,7.3,3.5,4.5C6.4,1.3,10,0.3,14,1.6c3.9,1.2,6.6,4.7,6.9,8.6c0.2,2.2-0.2,4.3-1.4,6.2 C16.7,20.9,14,25.4,11,30.2z" /></svg>;
export default SvgLocation;